import styled from "styled-components"

export const ProcedureSectionWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	gap: 24px;
	border-bottom: 1px solid #eaeafd;
	padding-bottom: 24px;
	.lastSection {
		display: flex;
		justify-content: flex-start;
		flex-direction: column;
		gap: 16px;
		background-color: #fafafa;
		padding: 16px;
		border-radius: 8px;
		.containerGuestLogin {
			display: flex;
			justify-content: flex-start;
			flex-direction: column;
			gap: 16px;
			.buttonGuestLogin {
				background-color: #fff;
				border: 1px solid #eaeef4;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 12px;
				border-radius: 8px;
				div {
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					&:first-child {
						width: calc(100% - 20px);
						font-weight: 500;
						font-size: 14px;
						text-align: center;
						color: #261b6a;
					}
					&:last-child {
						color: #261b6a;
						width: 20px;
					}
				}
			}
			.bodyGuestLogin {
				label {
					p {
						font-weight: 400;
						font-size: 14px;
					}
					textarea {
						height: 150px;
					}
				}
			}
		}
		.AutomationCentreAddVariable {
			display: flex;
			justify-content: flex-end;
			button {
				border: 1px solid #000;
				background-color: transparent;
				border: none;
				display: flex;
				gap: 8px;
				span {
					color: #5b3fff;
					font-weight: 500;
					font-size: 14px;
					line-height: 16.8px;
					&:first-child {
						font-size: 10px;
					}
				}
			}
		}
	}
`
